"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyId: zod_1.z.number().int(),
    dateFrom: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    dateTo: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    emails: zod_1.z.array(zod_1.z.string().email()).max(10).optional(),
});
exports.path = '/on-demand-irrigation-report-create';
//# sourceMappingURL=index.js.map